import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as ReactNamespace from 'react';
import * as ReactDOMNamespace from 'react-dom';

// Host-React für dynamisch geladene Template-Bundles bereitstellen (s. public/template-shims/).
(window as unknown as Record<string, unknown>).__VCARD_HOST_REACT__ = ReactNamespace;
(window as unknown as Record<string, unknown>).__VCARD_HOST_REACT_DOM__ = ReactDOMNamespace;

// Development startup logs
console.log('🚀 BMC-vCard Frontend starting...');
console.log('📦 React Version:', React.version);
console.log('🌍 Environment:', process.env.NODE_ENV);
console.log('🔗 Base URL:', window.location.origin);
console.log('⚡ Vite mode detected');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);

console.log('✅ BMC-vCard Frontend successfully mounted');